import { getAdvancedParamValues, getRapBackParamValues } from "../getParamValues";
import { checkInvalidDate } from "../queryTransactionsHelpers";
import { UserConfig } from "../../state/UserStore";
import dayjs from "dayjs";
import { getCurrentEnv } from "../getCurrentEnv";
import { QueryParams } from "../../interfaces/common";

const STATE = getCurrentEnv;

export const generateRBSubscriptionQueryParams = (pageName: string, searchParams, filterLabels, filterNumbers, orderBy, order, param): QueryParams => {
    console.log('debug getAdvancedParamValues 101010101 debug getParamValues rb simple search: ', {
        searchParams,
        conditionalA: getAdvancedParamValues("dob", searchParams, "lowerDate"),
        conditionalB: getAdvancedParamValues("lowerDobDate", searchParams),
        value: param?.column === "dob" ? getAdvancedParamValues("dob", searchParams, "lowerDate") : getAdvancedParamValues("lowerDobDate", searchParams),
        col: param?.column,
        param
    })

    return [
        {
            "value": 'true', // 'true' or 'false' only returning if isAdmin  is set to true
            "name": "isAdmin"
        },
        {
            "value": "null", //getAdvancedParamValues("days", searchParams, undefined, pageName),
            "name": "days"
        },
        {
            "value": orderBy === "receivedDate" ? "needsConfirmDate" : orderBy === "primaryOri" ? "ori" : orderBy, //"default" is value in an example
            "name": "orderBy"
        },
        {
            "value": order,
            "name": "order"
        },
        {
            "value": getAdvancedParamValues("fullName", searchParams),
            "name": "fullName"
        },
        {
            "value": getAdvancedParamValues("firstName", searchParams),
            "name": "firstName"
        },

        {
            "value": getAdvancedParamValues("lastName", searchParams),
            "name": "lastName"
        },
        {
            "value": getAdvancedParamValues("ssn", searchParams),
            "name": "ssn"
        },
        {
            "value": getAdvancedParamValues("rfp", searchParams),
            "name": "rfp"
        },
        {
            "value": getAdvancedParamValues("lsTcn", searchParams),
            "name": "lsTcn"
        },
        {
            "value": getAdvancedParamValues("afisTcn", searchParams),
            "name": "afisTcn"
        },
        {
            "value": getAdvancedParamValues("primaryOri", searchParams),
            "name": "ori"
        },
        {
            "value": getAdvancedParamValues("secondaryOri", searchParams),
            "name": "secondaryOri"
        },
        {
            "value": pageName === "rapback-maintenance" ? JSON.stringify(filterLabels) : "null",
            "name": "selectedStatus"
        },
        {
            "value": getAdvancedParamValues("status", searchParams),
            "name": "status"
        },
        {
            "value": getAdvancedParamValues("cri", searchParams),
            "name": "cri"
        },
        {
            "value": `${pageName === "rapback-maintenance" ? "null" : false}`,
            "name": "isPending"
        },

        {
            "value": `${pageName === "rapback-validations" ? true : "null"}`,
            "name": "isActive"
        },
        // Comment out for now until backend can handle different filtering days - Joseph
        // {
        //     "value": `${
        //         pageName === "rapback-validations" ?
        //             (filterLabels.length === 0 ? "0" : filterLabels.length === filterNumbers.length ? "60" :
        //                 filterLabels.some(num => filterNumbers.includes(num))
        //                 ? Math.max(...filterLabels).toString()
        //                 : "60")
        //         : "null"
        //     }`,
        //     "name": "expiryDaysLimit"
        // },
        {
            "value": `${(pageName === "rapback-validations") ? "60" : "null"}`,
            "name": "expiryDaysLimit"
        },
        {
            "value": `${pageName === "rapback-validations" ? getAdvancedParamValues("daysToExpire", searchParams) : "null"}`,
            "name": "daysToExpire"
        },
        {
            "value": `${pageName === "rapback-prenotifications" ? true : "null"}`,
            "name": "needsConfirm"
        },

        {
            "value": getAdvancedParamValues("rapbackSubId", searchParams),
            "name": "rapbackSubId" //this query param name should be updated on backend to match what comes back in response rapbackSubId
        },
        {
            "value": param?.column === "dob" ? checkInvalidDate(getAdvancedParamValues("dob", searchParams, "lowerDate")) : checkInvalidDate(getAdvancedParamValues("lowerDobDate", searchParams)),
            "name": "lowerDobDate"
        },
        {
            "value": param?.column === "dob" ? checkInvalidDate(getAdvancedParamValues("dob", searchParams, "upperDate")) : checkInvalidDate(getAdvancedParamValues("upperDobDate", searchParams)),
            "name": "upperDobDate"
        },
        {
            "value": param?.column === "fingerPrintDate" ? checkInvalidDate(getAdvancedParamValues("fingerPrintDate", searchParams, "lowerDate")) : checkInvalidDate(getAdvancedParamValues("lowerFingerPrintDate", searchParams)),
            "name": "lowerFingerPrintDate"
        },
        {
            "value": param?.column === "fingerPrintDate" ? checkInvalidDate(getAdvancedParamValues("fingerPrintDate", searchParams, "upperDate")) : checkInvalidDate(getAdvancedParamValues("upperFingerPrintDate", searchParams)),
            "name": "upperFingerPrintDate"
        },
        {
            "value": param?.column === "expirationDate"
                ? checkInvalidDate(getAdvancedParamValues("expirationDate", searchParams, "lowerDate"))
                : checkInvalidDate(getAdvancedParamValues("lowerExpirationDate", searchParams)),
            "name": "lowerExpirationDate"
        },
        {
            "value": param?.column === "expirationDate"
                ? checkInvalidDate(getAdvancedParamValues("expirationDate", searchParams, "upperDate"))
                : checkInvalidDate(getAdvancedParamValues("upperExpirationDate", searchParams)),
            "name": "upperExpirationDate"
        },
        {
            "value": param?.column === "subscriptionDate" ? checkInvalidDate(getAdvancedParamValues("subscriptionDate", searchParams, "lowerDate")) : checkInvalidDate(getAdvancedParamValues("lowerSubscriptionDate", searchParams)),
            "name": "lowerSubscriptionDate"
        },
        {
            "value": param?.column === "subscriptionDate" ? checkInvalidDate(getAdvancedParamValues("subscriptionDate", searchParams, "upperDate")) : checkInvalidDate(getAdvancedParamValues("upperSubscriptionDate", searchParams)),
            "name": "upperSubscriptionDate"
        },
        {
            "value": param?.column === "receivedDate" ? checkInvalidDate(getAdvancedParamValues("receivedDate", searchParams, "lowerDate")) : checkInvalidDate(getAdvancedParamValues("lowerNeedsConfirmDate", searchParams)), //received data from pre-notifications
            "name": "lowerNeedsConfirmDate"
        },
        {
            "value": param?.column === "receivedDate" ? checkInvalidDate(getAdvancedParamValues("receivedDate", searchParams, "upperDate")) : checkInvalidDate(getAdvancedParamValues("upperNeedsConfirmDate", searchParams)),
            "name": "upperNeedsConfirmDate"
        },
        {
            "value": param?.column === "deletionDate" ? checkInvalidDate(getAdvancedParamValues("deletionDate", searchParams, "lowerDate")) : checkInvalidDate(getAdvancedParamValues("lowerDeletionDate", searchParams)), //received data from pre-notifications
            "name": "lowerDeletionDate"
        },
        {
            "value": param?.column === "deletionDate" ? checkInvalidDate(getAdvancedParamValues("deletionDate", searchParams, "upperDate")) : checkInvalidDate(getAdvancedParamValues("upperDeletionDate", searchParams)),
            "name": "upperDeletionDate"
        },
    ]
}

export const generateRapBackQueryParams = (filterLabels, isAdmin, orderBy, order, searchParams): QueryParams => {
    return [
        {
            "value": isAdmin,
            "name": "isAdmin"
        },
        {
            "value": '90',
            "name": "days"
        },
        {
            "value": orderBy || "default",
            "name": "orderBy"
        },
        {
            "name": "selectedLastViewStatus",
            "value": JSON.stringify(filterLabels)
        },
        {
            "value": getRapBackParamValues("firstName", searchParams),
            "name": "firstName"
        },
        {
            "value": getRapBackParamValues("tcn", searchParams),
            "name": "tcn"
        },
        {
            "value": getRapBackParamValues("middleName", searchParams),
            "name": "middleName"
        },
        {
            "value": getRapBackParamValues("lastName", searchParams),
            "name": "lastName"
        },
        {
            "value": getRapBackParamValues("sid", searchParams),
            "name": "sid"
        },
        {
            "value": getRapBackParamValues("ssn", searchParams),
            "name": "ssn"
        },
        {
            "value": getRapBackParamValues("reason", searchParams),
            "name": "reason"
        },
        {
            "value": getRapBackParamValues("agency", searchParams),
            "name": "agency"
        },
        {
            "value": getRapBackParamValues("isHit", searchParams) === "hit" ? "Y" : "null",
            "name": "isHit"
        },
        ...STATE === "ga"
            ? [{
                "value": getRapBackParamValues("primaryOri", searchParams),
                "name": "primaryOri"
            },
            {
                "value": getRapBackParamValues("secondaryOri", searchParams),
                "name": "secondaryOri"
            }]
            : [{
                "value": getRapBackParamValues("ori", searchParams),
                "name": "ori"
            }],
        {
            "value": "null",
            "name": "rapbackSubId"
        },
        {
            // not in the mui table for dob
            "value": getRapBackParamValues("dob", searchParams),
            "name": "lowerDobDate"
        },
        {
            "value": getRapBackParamValues("dob", searchParams),
            "name": "upperDobDate"
        },
        {
            // no rapback date
            "value": getRapBackParamValues("rapbackdate", searchParams), // dayjs(rapbackdate[0]).format("YYYYMMDD") ,
            "name": "lowerRapbackDate"
        },
        {
            "value": getRapBackParamValues("rapbackdate", searchParams),
            "name": "upperRapbackDate"
        },
        {
            "value": getRapBackParamValues("insertDate", searchParams, "lowerDate"),
            "name": "lowerInsertDate"
        },
        {
            "value": getRapBackParamValues("insertDate", searchParams, "upperDate"),
            "name": "upperInsertDate"
        },
        {
            "value": order,
            "name": "order"
        }
        // {
        //     // only insert Date in the mui table
        //     "value": getParamValues("insertdate", "lowerDate") ,
        //     "name": "lowerInsertDate"
        // },
        // {
        //     "value": getParamValues("insertdate", "upperDate"),
        //     "name": "upperInsertDate"
        // }
    ]
}